import React, {useMemo, useState} from 'react';
import {Modal} from 'antd';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faXmark} from '@fortawesome/pro-regular-svg-icons';
import styles from './styles.module.scss';
import {StepOne} from './StepOne';
import {StepTwo} from './StepTwo';
import {StepThree} from './StepThree';
import {useStore} from '@/store/root-store';
import {observer} from 'mobx-react';
import {getCorrectUrl} from '@/utils/url';
interface DiagnosticModalProps {
  visible: boolean;
  setVisible: (val: boolean) => void;
  record: any;
}

export const DiagnosticModal: React.FC<DiagnosticModalProps> = observer(({
  visible,
  setVisible,
  record,
}) => {
  const {ottoV2Store: {getInstallationDiagnostics, getOttoV2Project}} = useStore('');
  const [url, setUrl] = useState('');
  const [data, setData] = useState(null);

  const onRunDiagnostics = async () => {
    setStep(1);
    try {
      const response = await getInstallationDiagnostics({...(!url?.trim() ? {} : {'testing_url': getCorrectUrl(url, record?.hostname)}), 'project_uuid': getOttoV2Project?.uuid});
      setData(response);
    } catch (error) {
      setStep(0);
    }
    setStep(2);
  };
  const [step, setStep] = useState(0);
  const handleCancel = () => {
    setVisible(false);
  };


  // const [issueTypesFrontendMappingV2, setIssueTypesFrontendMappingV2] = useState([]);


  const getIssues = issues => {
    return issues?.reduce((acc, issue) => {
      if (issue?.subGroups?.length > 0) {
        return {...acc, ...getIssues(issue.subGroups)};
      } else {
        return {...acc, [issue.group]: issue.label};
      }
    }, {});
  };


  const issueTypesFrontendMappingV2= useMemo(()=>{
    const clone = getIssues(getOttoV2Project?.issueTypesFrontendMappingV2);
    return clone;
  }, [getOttoV2Project?.issueTypesFrontendMappingV2]);

  const Steps = {
    0: <StepOne onRunDiagnostics={onRunDiagnostics} setVisible={setVisible} record={record} url={url} setUrl={setUrl} />,
    1: <StepTwo />,
    2: <StepThree record={record} url={url} data={data} issueTypesFrontendMappingV2={issueTypesFrontendMappingV2}/>,
  };

  return (
    <Modal
      open={visible}
      onCancel={handleCancel}
      width={560}
      centered
      footer={null}
      closeIcon={<FontAwesomeIcon icon={faXmark} fontSize={24} color='#A3A4A4' />}
      destroyOnClose
      className={styles.diagnosticModal}
    >
      {Steps[step]}
    </Modal>
  );
});
